import React from 'react'

const Manual_menu_comisiones = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          MENÚ - Comisiones
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Esta guía explica cómo configurar las comisiones en un sistema POS. Permite personalizar las comisiones y mejorar el seguimiento de ventas, siendo clave para motivar al personal y optimizar la gestión comercial.
        </p>
        <iframe
          src="https://scribehow.com/embed/MENU__Comisiones__tLG9til_SWCP2GucM5FFoQ?as=scrollable"
          className="scribe-iframe-general-14"
          width="100%"
          height="6500"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_menu_comisiones